/**
 * Simple logger wrapper that delegates to console methods.
 * Only logs when environment is not production.
 */

export const log = {
  debug: (...args: unknown[]): void => {
    if (!__PROD__) console.debug(...args);
  },
  info: (...args: unknown[]): void => {
    if (!__PROD__) console.info(...args);
  },
  warn: (...args: unknown[]): void => {
    if (!__PROD__) console.warn(...args);
  },
  warning: (...args: unknown[]): void => {
    if (!__PROD__) console.warn(...args);
  },
  error: (...args: unknown[]): void => {
    if (!__PROD__) console.error(...args);
  },
};
